export const getMicroDepositStatusStyles = (status) => {
    if (status === "verification_failed") {
        return {
            borderColor: "#D82000",
            labelClassName: "label-bkgWarning50",
            iconClassName: "icon-primary-persimon",
            text: "Unable to verify",
        };
    }

    return {
        borderColor: "#F0A446",
        labelClassName: "label-bkgSunshade50",
        iconClassName: "icon-primary-sunshade",
        text: "Pending verification",
    };
};
